import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { NAVIGATE_AUTH, NAVIGATE_MODULE, NAVIGATE_ADMIN } from '../constant';
import { PermissionProvider } from '../providers/PermissionProvider';

const AuthRoute = lazy(() => import('./AuthRoute'));
const GuestRoute = lazy(() => import('./GuestRoute'));
const AdminRoute = lazy(() => import('./AdminRoute'));
const UserRoute = lazy(() => import('./UserRoute'));
const LoaderText = lazy(() => import('../components/loader/LoaderText'));
const CommonDrawerComponent = lazy(() => import('../components/drawer'));

const AppRoute = () => {
    return (
        <>
            <Suspense fallback={<LoaderText />}>
                <Routes>
                    <Route path={`${NAVIGATE_AUTH.AUTH}/*`} element={<AuthRoute />} />
                    <Route path={`${NAVIGATE_ADMIN.ADMIN}/*`} element={ <PermissionProvider> <AdminRoute /> </PermissionProvider> } />
                    <Route path={`${NAVIGATE_MODULE.USER}/*`} element={<UserRoute />} />
                    <Route path={`${NAVIGATE_AUTH.LOGIN}`} element={<Navigate to={NAVIGATE_AUTH.LOGIN_PAGE} />} />
                    <Route path={`${NAVIGATE_MODULE.HOME}`} element={<Navigate to={'/home'} />} />
                    <Route path="*" element={<GuestRoute />} />
                </Routes>
            </Suspense>
            <Suspense fallback={<div>Loading drawer...</div>}>
                <CommonDrawerComponent />
            </Suspense>
        </>
    );
};

export default AppRoute;